import { useLocale } from '@koopajs/react';
import { Stack } from '@mui/material';
import { CommitteeTypeFacetSidebar } from '../Facets/CommitteeTypeFacetSidebar';
import { SortBySidebar } from '../Facets/SortBySidebar';
import { DateRangeFacetSidebar } from '../Facets/DateRangeFacetSidebar';

export const FacetListMinutesSidebar: React.FC = () => {
  const path = '/minutes';

  const { t } = useLocale();

  return (
    <Stack spacing={3}>
      <CommitteeTypeFacetSidebar path={path} />
      <DateRangeFacetSidebar path={path} facetKey="startDateTime" />

      <SortBySidebar
        sortOptions={[
          { key: 'startDateTime', direction: 'asc', label: t('Sidebars.SortBy.labelOldest') },
          { key: 'startDateTime', direction: 'desc', label: t('Sidebars.SortBy.labelNewest') }
        ]}
      />
    </Stack>
  );
};
